module.exports = __webpack_public_path__ + "static/media/logo1.7c02fa09.png";